(function(angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.bulkImport.name)

    .factory(schoolwork12.app.bulkImport.services.bulkImportSvc, ['$http', '$q', schoolwork12.app.auth.services.authentication,
        function($http, $q, authentication) {

            var downloadTemplate = function($scope, endpoint) {
                //var url = getEndPoint(bulkOption);
                console.info('In downloadTemplate service');
                $http({
                    url: endpoint + "/template/" + $scope.schoolId,
                    method: "GET",
                    responseType: 'arraybuffer',
                    headers: {
                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                    }
                }).then(function(response) {
                    console.info("Downloading attendance adjustment template");
                    console.log("response", response)

                    var header = response.headers('Content-Disposition');
                    var fileName = (header.split("=")[1].replace(/\"/gi, '')).split(".")[0];
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var objectUrl = URL.createObjectURL(blob);

                    console.log("header", header);
                    console.log("fileName", fileName);

                    var a = document.createElement("a");
                    a.href = objectUrl;
                    a.download = fileName + ".xlsx";

                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }, function(error) {
                    console.info('Error in getting attendance adjustment template....'.concat(angular.toJson(error)));
                    $scope.submissionErrorOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                });
            };

            var uploadFileToUrl = function($scope, endpoint, name) {
                var file;
                console.info('In uploadFileToUrl service');
                $scope.uploadSuccess = false;
                $scope.uploadErrorOccurred = false;
                $scope.failedPrevalidation = false;
                $scope.submissionErrorOccurred = false;
                $scope.completedUpload = false;
                $scope.closeSuccess = true;
                if($scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showGradPlan && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    file  = $scope.bulkImportAttAdjFile;
                }
                if(!$scope.showAttAdjustment && $scope.showAdditionReq && !$scope.showGradPlan && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    file  = $scope.bulkImportAddReqFile;
                }
                if($scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showCourseCatalog && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    file  = $scope.bulkImportGradPlanFile;
                }
                if($scope.showCourseCatalog && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showSchoolHolidayDetails && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    file = $scope.bulkImportCourseCatalogFile;
                }
                if($scope.showSchoolHolidayDetails && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showCourseCatalog && !$scope.showSchoolDatesDetails && !$scope.showStudentCreateDetails){
                    file = $scope.bulkImportSchoolHolidayFile;
                }
                if($scope.showSchoolDatesDetails  && !$scope.showSchoolHolidayDetails && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showCourseCatalog && !$scope.showStudentCreateDetails){
                    file = $scope.bulkImportSchoolDatesFile;
                }
                if($scope.showStudentCreateDetails && !$scope.showSchoolDatesDetails  && !$scope.showSchoolHolidayDetails && !$scope.showGradPlan && !$scope.showAttAdjustment && !$scope.showAdditionReq && !$scope.showCourseCatalog){
                    file = $scope.bulkImportStudentCreateFile;
                }

                if(file){
                    $scope.isSpinnerActive = true;
                    var fd = new FormData();
                    fd.append('file', file);
                    var url = endpoint + "/template";
                    $http.post(url, fd, {
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined,
                            'X-API-TOKEN': authentication.getCurrentUser().keycode
                        }
                    }).then(function(response) {
                        console.info('Uploaded '||name||' template', response);
                        var resp = response.data;
                        $scope.isSpinnerActive = false;

                        if (resp && resp.status == schoolwork12.app.bulkStatus.failPrevalidation) {
                            $scope.failedPrevalidation = true;
                            $scope.uploadErrorMsg = schoolwork12.app.bulkImport.errorMessages.failPrevalidation;
                        } else {
                            $scope.uploadSuccess = true;
                            $scope.failedPrevalidation = false;
                            $scope.uploadSuccessMsg = resp.message;
                        }
                        $scope.bulkRequestId = resp.requestId;
                        $scope.completedUpload = true;
                    }, function(error) {
                        console.info('Error uploading '+ name +' template....'.concat(angular.toJson(error)));
                        $scope.submissionErrorOccurred = true;
                        $scope.isSpinnerActive = false;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.submissionErrorMesg = error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    });
                } else {
                    $scope.uploadErrorOccurred = true;
                    $scope.uploadErrorMsg = schoolwork12.app.bulkImport.errorMessages.selectFileRequired;
                }
            };

            var downloadErrorTemplate = function($scope, bulkRequestId, endpoint) {
                console.info('In downloadErrorTemplate service');
                var schoolId = $scope.schoolId;
                $http({
                    url: endpoint + "/" + bulkRequestId + "/errors/"+schoolId,
                    method: "GET",
                    responseType: 'arraybuffer',
                    headers: {
                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                    }
                }).then(function(response) {
                    console.info("Downloading error logs");
                    var header = response.headers('Content-Disposition')
                    var fileName = (header.split("=")[1].replace(/\"/gi, '')).split(".")[0];
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var objectUrl = URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    a.href = objectUrl;
                    a.download = fileName + ".xlsx";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }, function(error) {
                    console.info('Error in viewing submission logs grid....'.concat(angular.toJson(error)));
                    $scope.submissionErrorOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                });
            };

            return {
                downloadTemplate: downloadTemplate,
                downloadErrorTemplate: downloadErrorTemplate,
                uploadFileToUrl: uploadFileToUrl
            };

        }
    ]);

}(angular, schoolwork12));
